<template>
  <div>
    <div class="banner">
      <div class="titleSub">Full custody</div>
      <div class="title wow animate__animated durationTime animate__fadeInUp">
        全程托管
      </div>
      <div class="desc wow animate__animated durationTime animate__fadeInUp">
        提供一站式全程项目托管服务，遵循标准化的操作流程(SOP)确保项目建设与运营的高效和规范。
      </div>
    </div>
    <div class="con">
      <div class="t">项目执行的八大步骤及其价值点</div>
      <div class="box">
        <img style="width: 1.6946rem;height: 12.3256rem" src="../../assets/image/xplan/trusteeship-con.png">
        <div class="rg">
          <div class="item wow animate__animated durationTime animate__fadeInUp">
            <div class="first">
              项目勘察
            </div>
            <div class="second">
              通过全面的现场调查，确保对项目环境有深入了解，为后续的设计和施工提供准确的基础数据，降低项目风险。
            </div>
          </div>
          <div class="item wow animate__animated durationTime animate__fadeInUp">
            <div class="first">
              用户调研
            </div>
            <div class="second">
              深入了解目标用户的需求和偏好，为项目提供定制化的解决方案，提高用户满意度和项目成功率。
            </div>
          </div>
          <div class="item wow animate__animated durationTime animate__fadeInUp">
            <div class="first">
              方案设计
            </div>
            <div class="second">
              深入了解目标用户的需求和偏好，为项目提供定制化的解决方案，提高用户满意度和项目成功率。
            </div>
          </div>
          <div class="item wow animate__animated durationTime animate__fadeInUp">
            <div class="first">
              项目立项评审
            </div>
            <div class="second" >
              通过多方面的评估和审查，确保项目的技术可行性、市场需求满足度、风险可控性和资源优化配置，提前识别潜在问题，减少项目实施过程中的风险和不确
              定性。为项目的顺利实施打下坚实基础。
            </div>
          </div>
          <div class="item wow animate__animated durationTime animate__fadeInUp">
            <div class="first">
              项目执行与交付
            </div>
            <div class="second">
              标准化和规程化的施工管理流程，确保项目按时按质完成，同时满足成本控制和质量保证的要求。
            </div>
          </div>
          <div class="item wow animate__animated durationTime animate__fadeInUp">
            <div class="first">
              项目推广与运营
            </div>
            <div class="second">
              通过有效的推广策略和运营手段，提高项目知名度和市场占有率，实现商业价值的最大化。
            </div>
          </div>
          <div class="item wow animate__animated durationTime animate__fadeInUp">
            <div class="first">
              运维
            </div>
            <div class="second">
              持续的运维管理确保网络服务的稳定性和安全性，提升用户体验，增强客户忠诚度。
            </div>
          </div>
          <div class="item wow animate__animated durationTime animate__fadeInUp">
            <div class="first">
              客服
            </div>
            <div class="second">
              建立高效的客服体系，快速响应和解决用户问题，提升服务质量，构建良好的品牌形象。
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
export default {
  name: "trusteeship",
  data() {
    return {
      detail: [],
      detailTitle:[],
      activeTab:'',
      activeCon:{},
      products:[],
    };
  },
  created() {

  },
  methods: {},
  mounted() {
    // init wow
    const wow = new WOW({
      boxClass: "wow", //需要执行动画元素的Class
      animateClass: "animated_lightSpeedIn", //animation.css动画的Class
      offset: 0, //距离可视区域多少开始执行动画
      mobile: true, //是否在移动设备执行动画
      live: true //异步加载的内容是否有效
    });
    wow.init();
  },

};
</script>

<style scoped lang="scss">
.banner {
  width: 100%;
  height: 5.8rem;
  background: url("../../assets/image/xplan/trusteeship-bg.png") center
    no-repeat;
  background-size: cover;

  .title {
    font-size: 0.44rem;
    font-weight: 500;
    text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    margin-top: 2.25rem;
    margin-left: 2.18rem;
    position: relative;
    color: #fff;
    display: inline-block;
  }

  .titleSub {
    content: "";
    position: absolute;
    margin-top: 1.94rem;
    margin-left: 2.18rem;
    font-size: 0.44rem;
    font-weight: 500;
    color: rgb(169 160 160 / 51%);
    text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    letter-spacing: 0.02rem;
  }

  .desc {
    font-weight: 400;
    font-size: 0.24rem;
    color: #ffffff;
    margin-top: 0.2rem;
    margin-left: 2.18rem;
    width: 10.01rem;
  }

}
.con{
  padding: 1rem 2.18rem;
  .t{
    text-align: center;
    font-weight: 500;
    font-size: 0.32rem;
    color: #333333;
    margin-bottom: 0.8rem;
  }
  .box{
    display: flex;
    .rg{
      padding-top: 0.31rem;
      padding-left: 0.8rem;
      .item{
        margin-bottom: 0.75rem;
        .first{
          font-weight: 500;
          font-size: 0.24rem;
          color: #333333;
          margin-bottom: 0.2rem;
        }
        .second{
          font-weight: 400;
          font-size: 0.18rem;
          color: #666666;
          //line-height: 0.3rem;
        }
      }
    }
  }

}

</style>



// WEBPACK FOOTER //
// src/pages/xplan/trusteeship.vue